// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversationalWindow_container__l\\+rcA {
  width: 70%;
  height: 100%;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-end; }

.conversationalWindow_inputWrapper__x4J8X {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  padding: 6px;
  gap: 10px;
  border-radius: var(--Corner-radius, 4px);
  background: var(--website-white, #FFF);
  box-shadow: 0 0 8px 0 rgba(42, 98, 149, 0.25);
  justify-content: space-between; }
  .conversationalWindow_inputWrapper__x4J8X svg {
    height: 28px;
    width: 28px;
    cursor: pointer;
    fill: #666666; }
  .conversationalWindow_inputWrapper__x4J8X button {
    height: 32px; }

.conversationalWindow_textarea__G2t-u {
  padding: 4px 4px 4px 4px;
  border-width: 0;
  width: 70%;
  max-height: 200px;
  overflow-y: scroll;
  min-height: 48px;
  box-sizing: border-box;
  resize: none;
  background: none;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px; }

span[contenteditable]:empty:focus::before,
span[contenteditable]:empty::before {
  content: 'Ask your question';
  color: #9E9E9E; }

.conversationalWindow_chatInputBlock__AOkNs {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  column-gap: 8px; }
  .conversationalWindow_chatInputBlock__AOkNs select {
    border: none;
    background: transparent; }
    .conversationalWindow_chatInputBlock__AOkNs select :focus {
      border: none;
      background: none;
      outline: none; }
  .conversationalWindow_chatInputBlock__AOkNs input {
    min-width: 350px;
    height: 48px;
    border: none;
    background: none;
    outline: none; }
    .conversationalWindow_chatInputBlock__AOkNs input :focus {
      border: none;
      background: none;
      outline: none; }

.conversationalWindow_chatButtonsBlock__FHfN9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 12px;
  position: absolute;
  right: 10px; }

.conversationalWindow_useContextTag__ocUL5 {
  height: 30px;
  padding: 4px;
  font-size: 11px;
  border-radius: 15px;
  display: flex;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0; }

.conversationalWindow_chatMessageWrapper__2-PYw {
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  position: relative; }
  .conversationalWindow_chatMessageWrapper__2-PYw svg {
    height: 18px;
    width: 18px;
    cursor: pointer; }

.conversationalWindow_addChatButton__0s3Pj {
  width: 54px;
  height: 100%; }

.conversationalWindow_chatMessage__UiHAA {
  display: flex;
  max-width: 550px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--Corner-radius, 4px);
  background: var(--product-akcent-transperent, rgba(254, 97, 0, 0.1));
  align-self: flex-start !important; }

.conversationalWindow_chatMessageTitle__9GRvu {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #666666; }

.conversationalWindow_userMessage__qBWpQ {
  display: flex;
  max-width: 550px;
  padding: 10px;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  border-radius: var(--Corner-radius, 4px);
  border: 1px solid var(--product-on-surface-divider, #E0E0E0);
  background: var(--product-light-gray, #F3F4F6);
  align-self: flex-end !important; }

.conversationalWindow_modal__nktBl {
  max-width: 560px;
  max-height: 850px;
  height: max-content;
  overflow: hidden;
  position: relative;
  background-color: #ffffff;
  z-index: 2; }

.conversationalWindow_emptyChatPlaceholder__2obGi {
  height: 100%;
  width: 100%;
  flex-direction: column;
  row-gap: 4px;
  color: #9E9E9E;
  display: flex;
  align-items: center;
  justify-content: center; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/conversationlaWindow/conversationalWindow.module.scss","webpack://./src/styles/fonts.scss","webpack://./src/styles/common.scss"],"names":[],"mappings":"AAGA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,yBAAyB,EAAA;;AAG3B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,wCAAwC;EACxC,sCAAsC;EACtC,6CAA6C;EAC7C,8BAA8B,EAAA;EAXhC;IAaI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,aAAa,EAAA;EAhBjB;IAmBI,YAAY,EAAA;;AAIhB;EACE,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,aAAa;ECFb,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;ADInB;;EAEE,4BAA4B;EAC5B,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe,EAAA;EANjB;IAQI,YAAY;IACZ,uBAAuB,EAAA;IAT3B;MAWM,YAAY;MACZ,gBAAgB;MAChB,aAAa,EAAA;EAbnB;IAiBI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa,EAAA;IArBjB;MAuBM,YAAY;MACZ,gBAAgB;MAChB,aAAa,EAAA;;AAKnB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EEjGb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EFiGvB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EEzGX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EFyGvB,aAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EC3Eb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;ED2EjB,kBAAkB,EAAA;EAVpB;IAYI,YAAY;IACZ,WAAW;IACX,eAAe,EAAA;;AAInB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,oEAAqE;EACrE,iCAAgC,EAAA;;AAGlC;EC1FE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;ED0FjB,cAAc,EAAA;;AAGhB;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,4DAA4D;EAC5D,8CAA8C;EAC9C,+BAA8B,EAAA;;AAGhC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU,EAAA;;AAGZ;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,cAAc;EE3Kd,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.container {\n  width: 70%;\n  height: 100%;\n  align-items: flex-end;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  width: 100%;\n  padding: 6px;\n  gap: 10px;\n  border-radius: var(--Corner-radius, 4px);\n  background: var(--website-white, #FFF);\n  box-shadow: 0 0 8px 0 rgba(42, 98, 149, 0.25);\n  justify-content: space-between;\n  svg {\n    height: 28px;\n    width: 28px;\n    cursor: pointer;\n    fill: #666666;\n  }\n  button {\n    height: 32px;\n  }\n}\n\n.textarea {\n  padding: 4px 4px 4px 4px;\n  border-width: 0;\n  width: 70%;\n  max-height: 200px;\n  overflow-y: scroll;\n  min-height: 48px;\n  box-sizing: border-box;\n  resize: none;\n  background: none;\n  outline: none;\n  @include body2;\n}\n\nspan[contenteditable]:empty:focus::before,\nspan[contenteditable]:empty::before{\n  content: 'Ask your question';\n  color: #9E9E9E;\n}\n\n.chatInputBlock {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  flex-wrap: wrap;\n  column-gap: 8px;\n  select {\n    border: none;\n    background: transparent;\n    :focus {\n      border: none;\n      background: none;\n      outline: none;\n    }\n  }\n  input {\n    min-width: 350px;\n    height: 48px;\n    border: none;\n    background: none;\n    outline: none;\n    :focus {\n      border: none;\n      background: none;\n      outline: none;\n    }\n  }\n}\n\n.chatButtonsBlock {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  column-gap: 12px;\n  position: absolute;\n  right: 10px;\n}\n\n.useContextTag {\n  height: 30px;\n  padding: 4px;\n  font-size: 11px;\n  border-radius: 15px;\n  display: flex;\n  @include flexCenter;\n  background: #e0e0e0;\n}\n\n.chatMessageWrapper {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  width: 100%;\n  @include flexCenter;\n  display:flex;\n  flex-direction: column;\n  justify-content: space-between;\n  row-gap: 12px;\n  @include body1;\n  position: relative;\n  svg {\n    height: 18px;\n    width: 18px;\n    cursor: pointer;\n  }\n}\n\n.addChatButton {\n  width: 54px;\n  height: 100%;\n}\n\n.chatMessage{\n  display: flex;\n  max-width: 550px;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: var(--Corner-radius, 4px);\n  background: var(--product-akcent-transperent, rgba(254, 97, 0, 0.10));\n  align-self: flex-start!important;\n}\n\n.chatMessageTitle {\n  @include body3;\n  color: #666666;\n}\n\n.userMessage {\n  display: flex;\n  max-width: 550px;\n  padding: 10px;\n  justify-content: center;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 4px;\n  border-radius: var(--Corner-radius, 4px);\n  border: 1px solid var(--product-on-surface-divider, #E0E0E0);\n  background: var(--product-light-gray, #F3F4F6);\n  align-self: flex-end!important;\n}\n\n.modal {\n  max-width: 560px;\n  max-height: 850px;\n  height: max-content;\n  overflow: hidden;\n  position: relative;\n  background-color: #ffffff;\n  z-index: 2;\n}\n\n.emptyChatPlaceholder {\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n  row-gap: 4px;\n  color: #9E9E9E;\n  @include flexCenter\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n","\n@mixin flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `conversationalWindow_container__l+rcA`,
	"inputWrapper": `conversationalWindow_inputWrapper__x4J8X`,
	"textarea": `conversationalWindow_textarea__G2t-u`,
	"chatInputBlock": `conversationalWindow_chatInputBlock__AOkNs`,
	"chatButtonsBlock": `conversationalWindow_chatButtonsBlock__FHfN9`,
	"useContextTag": `conversationalWindow_useContextTag__ocUL5`,
	"chatMessageWrapper": `conversationalWindow_chatMessageWrapper__2-PYw`,
	"addChatButton": `conversationalWindow_addChatButton__0s3Pj`,
	"chatMessage": `conversationalWindow_chatMessage__UiHAA`,
	"chatMessageTitle": `conversationalWindow_chatMessageTitle__9GRvu`,
	"userMessage": `conversationalWindow_userMessage__qBWpQ`,
	"modal": `conversationalWindow_modal__nktBl`,
	"emptyChatPlaceholder": `conversationalWindow_emptyChatPlaceholder__2obGi`
};
export default ___CSS_LOADER_EXPORT___;
